import { styled as t } from "styled-components";
import { SmartLink as i } from "../SmartLink/index.js";
import { CaptionLight as a, CaptionHeavy as e, BodyHeavy as n, BodyLight as c } from "../../styles/typography/index.js";
import { Colors as l } from "../../styles/colors/index.js";
import { Theme as o } from "../../styles/themes/index.js";
import { MediaQuery as r } from "../../styles/variables.js";
const p = t.button`
  ${a}
  padding: 8px 16px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  background: transparent;

  i {
    font-size: 24px;
    margin-right: 4px;
    margin-left: -8px;
    color: rgb(${l.Gray});
  }

  &:hover {
    background-color: rgb(${o.colors.India});

    i {
      color: rgb(${o.colors.Brand});
    }
  }

  &[aria-selected='true'] {
    ${e}
    background-color: rgb(${o.colors.Bravo});
    color: rgb(${o.colors.Alpha});

    i {
      color: rgb(${o.colors.Brand});
    }

    @media ${r.SCREEN_MD_UP} {
      ${n}
    }
  }

  @media ${r.SCREEN_MD_UP} {
    ${c}
  }
`, f = t(p).attrs({ as: i })`
  text-decoration: none;
  color: rgb(${o.colors.Alpha});
`;
export {
  p as Button,
  f as TabButtonLink
};
